import { inSSRContext } from '@/lego/utils/render/ssr';
import { getScreenSize } from '@/lego/utils/tailwind/screen';

export function onResize(callback) {
  const size = getScreenSize();

  if (inSSRContext()) {
    callback(size);
    return;
  }

  window.addEventListener('resize', () => callback(size));
}

export function onMinWidth(minSize, callback) {
  onResize(size => {
    if (size.width >= minSize) {
      callback();
    }
  });
}
